import React from 'react';
import PropTypes from 'prop-types';

import i18n from '../../../i18n';

import Home from '../../../models/Home';

import { CounterInput, Icon, Divider, Flex, Text } from '@homeexchange/design';

const TRACKING_BEDS_NUMDER_CHNAGED = 'beds_number_changed';

const InputBedList = ({ home, onChange }) => (
    <Flex direction="column" gap="0" isFullWidth>
        <Flex direction="column" gap="4" isFullWidth>
            <Text isBold>{i18n.t('home:funnel.homeCreation.nbBeds.beds.title')}</Text>
            <Flex direction="column" gap="2" isFullWidth>
                <div className={'counter-option'}>
                    <label className={'counter-option-label'}>
                        <Icon size="large" name="BedKing" />
                        <div className={'counter-option-label-text'}>
                            {i18n.t('global:global.beds.kingSize')}
                            <span className={'counter-option-description'}>
                                {i18n.t('global:global.beds.kingSize.desc')}
                            </span>
                        </div>
                    </label>
                    <CounterInput
                        minValue={0}
                        maxValue={15}
                        name="detail.big_double_bed"
                        onChange={(value) =>
                            onChange(
                                null,
                                {},
                                {
                                    name: 'detail.big_double_bed',
                                    value,
                                    track: TRACKING_BEDS_NUMDER_CHNAGED
                                }
                            )
                        }
                        inputInitialValue={home.get('detail').big_double_bed || 0}
                    />
                </div>
                <div className={'counter-option'}>
                    <label className={'counter-option-label'}>
                        <Icon size="large" name="BedDouble" />
                        <div className={'counter-option-label-text'}>
                            {i18n.t('global:global.beds.queenSize')}
                            <span className={'counter-option-description'}>
                                {i18n.t('global:global.beds.queenSize.desc')}
                            </span>
                        </div>
                    </label>
                    <CounterInput
                        minValue={0}
                        maxValue={15}
                        name="detail.double_bed"
                        onChange={(value) =>
                            onChange(
                                null,
                                {},
                                {
                                    name: 'detail.double_bed',
                                    value,
                                    track: TRACKING_BEDS_NUMDER_CHNAGED
                                }
                            )
                        }
                        inputInitialValue={home.get('detail').double_bed || 0}
                    />
                </div>
                <div className={'counter-option'}>
                    <label className={'counter-option-label'}>
                        <Icon size="large" name="BedSingle" />
                        <div className={'counter-option-label-text'}>
                            {i18n.t('global:global.beds.single')}
                            <span className={'counter-option-description'}>
                                {i18n.t('global:global.beds.single.desc')}
                            </span>
                        </div>
                    </label>
                    <CounterInput
                        minValue={0}
                        maxValue={15}
                        name="detail.single_bed"
                        onChange={(value) =>
                            onChange(
                                null,
                                {},
                                {
                                    name: 'detail.single_bed',
                                    value,
                                    track: TRACKING_BEDS_NUMDER_CHNAGED
                                }
                            )
                        }
                        inputInitialValue={home.get('detail').single_bed || 0}
                    />
                </div>
                <Divider space="small" />
                <div className={'counter-option'}>
                    <label className={'counter-option-label'}>
                        <Icon size="large" name="BedChild" />
                        <div className={'counter-option-label-text'}>
                            {i18n.t('global:global.beds.child')}
                            <span className={'counter-option-description'}>
                                {i18n.t('global:global.beds.child.desc')}
                            </span>
                        </div>
                    </label>
                    <CounterInput
                        minValue={0}
                        maxValue={15}
                        name="detail.children_bed"
                        onChange={(value) =>
                            onChange(
                                null,
                                {},
                                {
                                    name: 'detail.children_bed',
                                    value,
                                    track: TRACKING_BEDS_NUMDER_CHNAGED
                                }
                            )
                        }
                        inputInitialValue={home.get('detail').children_bed || 0}
                    />
                </div>
                <div className={'counter-option'}>
                    <label className={'counter-option-label'}>
                        <Icon size="large" name="BabyStroller" />
                        <div className={'counter-option-label-text'}>
                            {i18n.t('global:global.beds.crib')}
                            <span className={'counter-option-description'}>
                                {i18n.t('global:global.beds.crib.desc')}
                            </span>
                        </div>
                    </label>
                    <CounterInput
                        minValue={0}
                        maxValue={15}
                        name="detail.baby_bed"
                        onChange={(value) =>
                            onChange(
                                null,
                                {},
                                {
                                    name: 'detail.baby_bed',
                                    value,
                                    track: TRACKING_BEDS_NUMDER_CHNAGED
                                }
                            )
                        }
                        inputInitialValue={home.get('detail').baby_bed || 0}
                    />
                </div>
            </Flex>
            <div>
                <Text isBold>{i18n.t('home:funnel.homeCreation.nbBeds.putupBeds.title')}</Text>
                <Text className="counter-sub-title">
                    {i18n.t('home:funnel.homeCreation.nbBeds.putupBeds.subtitle')}
                </Text>
            </div>
            <Flex direction="column" gap="2" isFullWidth>
                <div className={'counter-option'}>
                    <label className={'counter-option-label'}>
                        <Icon size="large" name="SofaBedDouble" />
                        <div className={'counter-option-label-text'}>
                            {i18n.t('global:global.putUpBeds.double')}
                            <span className={'counter-option-description'}>
                                {i18n.t('global:global.putUpBeds.double.desc')}
                            </span>
                        </div>
                    </label>
                    <CounterInput
                        minValue={0}
                        maxValue={15}
                        name="detail.double_bed_up"
                        onChange={(value) =>
                            onChange(
                                null,
                                {},
                                {
                                    name: 'detail.double_bed_up',
                                    value,
                                    track: TRACKING_BEDS_NUMDER_CHNAGED
                                }
                            )
                        }
                        inputInitialValue={home.get('detail').double_bed_up || 0}
                    />
                </div>
                <div className={'counter-option'}>
                    <label className={'counter-option-label'}>
                        <Icon size="large" name="SofaBedSingle" />
                        <div className={'counter-option-label-text'}>
                            {i18n.t('global:global.putUpBeds.single')}
                            <span className={'counter-option-description'}>
                                {i18n.t('global:global.putUpBeds.single.desc')}
                            </span>
                        </div>
                    </label>
                    <CounterInput
                        minValue={0}
                        maxValue={15}
                        name="detail.single_bed_up"
                        onChange={(value) =>
                            onChange(
                                null,
                                {},
                                {
                                    name: 'detail.single_bed_up',
                                    value,
                                    track: TRACKING_BEDS_NUMDER_CHNAGED
                                }
                            )
                        }
                        inputInitialValue={home.get('detail').single_bed_up || 0}
                    />
                </div>
                <Divider space="small" />
                <div className={'counter-option'}>
                    <label className={'counter-option-label'}>
                        <Icon size="large" name="Sofa" />
                        <div className={'counter-option-label-text'}>
                            {i18n.t('global:global.putUpBeds.child')}
                            <span className={'counter-option-description'}>
                                {i18n.t('global:global.putUpBeds.child.desc')}
                            </span>
                        </div>
                    </label>
                    <CounterInput
                        minValue={0}
                        maxValue={15}
                        name="detail.children_bed_up"
                        onChange={(value) =>
                            onChange(
                                null,
                                {},
                                {
                                    name: 'detail.children_bed_up',
                                    value,
                                    track: TRACKING_BEDS_NUMDER_CHNAGED
                                }
                            )
                        }
                        inputInitialValue={home.get('detail').children_bed_up || 0}
                    />
                </div>
                <div className={'counter-option'}>
                    <label className={'counter-option-label'}>
                        <Icon size="large" name="BabyStroller" />
                        <div className={'counter-option-label-text'}>
                            {i18n.t('global:global.putUpBeds.crib')}
                            <span className={'counter-option-description'}>
                                {i18n.t('global:global.putUpBeds.crib.desc')}
                            </span>
                        </div>
                    </label>
                    <CounterInput
                        minValue={0}
                        maxValue={15}
                        name="detail.baby_bed_up"
                        onChange={(value) =>
                            onChange(
                                null,
                                {},
                                {
                                    name: 'detail.baby_bed_up',
                                    value,
                                    track: TRACKING_BEDS_NUMDER_CHNAGED
                                }
                            )
                        }
                        inputInitialValue={home.get('detail').baby_bed_up || 0}
                    />
                </div>
            </Flex>
        </Flex>
    </Flex>
);

InputBedList.propTypes = {
    home: PropTypes.instanceOf(Home).isRequired,
    onChange: PropTypes.func.isRequired
};

export default InputBedList;
